import { render } from "./App.vue?vue&type=template&id=7a2d09d4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7a2d09d4&lang=css"

import exportComponent from "F:\\duoji\\vue3\\vue3_demo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__